import { Typography } from '@design-system/components/typography/typography';
import {
  alert,
  sectionWrapper,
  icon,
  wrapper,
  info,
  tilesWrapper,
} from './HowItWorks.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle,
  faPlusCircle,
  faUserCircle,
} from '@fortawesome/pro-regular-svg-icons';
import { Divider } from '@mui/material';
import { Col, Row } from '@design-system/components/grid/grid';
import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';

export const HowItWorks = () => (
  <div className={wrapper}>
    <Typography variant="headline" size="large" align="center">
      Here’s how it works
    </Typography>
    <Typography variant="body" size="medium">
      Your platform subscription stays active. Your new Exclusive subscription
      runs alongside it.
    </Typography>
    <div className={tilesWrapper}>
      <div className={clsx(sectionWrapper, sprinkles({ bg: 'N-10' }))}>
        <Col className="gap-2">
          <Typography variant="body" size="small" color="N-80">
            STAYS THE SAME
          </Typography>
          <Typography variant="headline" size="small">
            Platform
          </Typography>
          <Typography variant="body" size="medium" fontWeight="normal">
            $14.99/mo - locked
          </Typography>
        </Col>
        <Divider
          className={sprinkles({ borderColor: 'N-40', width: '100%' })}
        />
        <Col className="gap-2">
          <Row className={sprinkles({ color: 'N-60', gap: 's' })}>
            <FontAwesomeIcon icon={faUserCircle} />
            <FontAwesomeIcon icon={faUserCircle} />
            <FontAwesomeIcon icon={faUserCircle} />
          </Row>
          <Typography variant="body" size="medium">
            Current subscribers
          </Typography>
          <Col className="gap-0">
            <Typography variant="body" size="medium" fontWeight="normal">
              Keep their access and price.
            </Typography>
            <Typography variant="body" size="medium" fontWeight="normal">
              You control what content they see.
            </Typography>
          </Col>
        </Col>
      </div>
      <FontAwesomeIcon
        icon={faPlusCircle}
        className={sprinkles({ color: 'N-60' })}
      />
      <div
        className={clsx(
          sectionWrapper,
          sprinkles({ bg: 'P-20', borderColor: 'P-80' }),
        )}
      >
        <Col className="gap-2">
          <Typography variant="body" size="small" color="P-80">
            NEW
          </Typography>
          <Typography variant="headline" size="small">
            Exclusive
          </Typography>
          <Typography variant="body" size="medium" color="P-80">
            You set the price
          </Typography>
        </Col>
        <Divider
          className={sprinkles({ borderColor: 'P-40', width: '100%' })}
        />
        <Col className="gap-2">
          <Row className={sprinkles({ gap: 's' })}>
            <FontAwesomeIcon
              icon={faUserCircle}
              className={sprinkles({ color: 'P-80' })}
            />
            <FontAwesomeIcon
              icon={faUserCircle}
              className={sprinkles({ color: 'P-80' })}
            />
            <FontAwesomeIcon
              icon={faUserCircle}
              className={sprinkles({ color: 'P-40' })}
            />
          </Row>
          <Typography variant="body" size="medium">
            New Subscribers
          </Typography>
          <Col className="gap-0">
            <Typography variant="body" size="medium" fontWeight="normal">
              Your content, your price.
            </Typography>
            <Typography variant="body" size="medium" fontWeight="normal">
              Your own walled garden.
            </Typography>
          </Col>
        </Col>
      </div>
    </div>
    <div className={alert}>
      <FontAwesomeIcon icon={faInfoCircle} className={icon} />
      <Typography variant="body" size="medium" fontWeight="normal">
        <b>Your content, your call.</b> Push the same content to both
        subscriptions or start differentiating over time. It’s completely up to
        you
      </Typography>
    </div>
    <div className={info}>
      <Typography variant="body" size="medium" fontWeight="normal" color="N-80">
        *Soon you’ll be able to sell multiple subscriptions at once. Stay tuned.
      </Typography>
    </div>
  </div>
);
